import Vue from 'vue';
import {
  formatNumber,
  alignForNumber,
  LinkCellRenderer,
  autoResize
} from '@/helpers/renderHelpers'
import { addColIdToColumns, handlerResponse } from "@/helpers/commonHelpers";

export default {
  namespaced: true,
  state: {
    comments: [],
    documents: [],
    partnerContacts: [],
    partnerContactsGridColumns: [],
    gridOptions: {
      animateRows: true,
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        valueFormatter(params) {
          return formatNumber(params.value, null)
        },
        cellStyle(params) {
          return alignForNumber(params.value);
        }
      },
      onRowDataChanged() {
        if (this.rowData && this.rowData.length) {
          autoResize(this);
        }
      }
    }
  },
  getters: {
    partnerContactsGrid(state) {
      return {...state.gridOptions};
    }
  },
  mutations: {
    setCommentsList(state, data) {
      state.comments = data;
    },
    setDocumentsList(state, data) {
      state.documents = data;
    },
    setPartnerContacts(state, data) {
      state.partnerContacts = data.data;
      state.partnerContactsGridColumns = addColIdToColumns(data.used_columns);
    }
  },
  actions: {
    loadCommentsList(store, payLoad) {
      Vue.http.get(`partner/partners/${payLoad.id}/comments/`)
        .then(handlerResponse)
        .then(data => {
          store.commit('setCommentsList', data);
        });
    },
    loadDocumentsList(store, payLoad) {
      Vue.http.get(`partner/partners/${payLoad.id}/attachments/`)
        .then(handlerResponse)
        .then(data => {
          store.commit('setDocumentsList', data);
        });
    },
    loadPartnerContacts(store, payLoad) {
      Vue.http.get(`partner/partners/${payLoad.id}/delivery_addresses/`)
        .then(handlerResponse)
        .then(data => {
          store.commit('setPartnerContacts', data);
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/general/partners/generalPartner.js